import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {optionsSearch} from "core/common/service/commonDataService";
import NewPartyDialog from "party/component/newPartyDialog";
import {lovLabel, lovParam, FormProps} from 'core/form/formUtils';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import {PartyRel, Party, PartyRole} from "party/partyDomain";
import {action} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {MdTextField} from 'core/components/fields/fields';
import {FIELDDEFDISPLAYTYPE} from "core/form/form";


const ClosedContent = ({dataObject, entity, entities, setDataAction, fields}) => (
  <div style={{fontSize: 16, lineHeight: '16px', minHeight: 20}}>
    {lovLabel(dataObject.relType)}
    {' '}
    { (dataObject.relType.directionFrom) ?  lovLabel(dataObject.toParty) : lovLabel(dataObject.fromParty)}
  </div>
);


@createForm({
  formName: 'PartyRelForm',
  fields: [{
    name: 'fromParty',
    validators: ['IsRequired'],
    usePlaceholder: true
  }, {
    name: 'toParty',
    validators: ['IsRequired'],
    usePlaceholder: true
  },{
    name: 'description'
  },{
    name: 'comments',
    displayType:  FIELDDEFDISPLAYTYPE.textArea
  }]
}, ClosedContent)
@observer
export default class PartyRelForm extends React.Component<FormProps<PartyRel, Party>, undefined> {


  private newPartyDialogRef: NewPartyDialog;

  @action newParty = () => {
    let {dataObject, rootObject, entities, formName} = this.props;
    let roleType = entities.get('PartyRoleType').getLovItem(dataObject.relType.roleId);

    let newPartyObject = new Party({
      active: true,
      $new: true,
      partyCategory: lovParam(roleType, 'defaultPartyCategory'),
      roles: [new PartyRole({roleType}).initDefaultValues()]
    }).initAfterRead(true);

    console.log("newParty roleType = %O", roleType);

    new Promise((resolve, reject) => {
      this.newPartyDialogRef.open(resolve, reject, newPartyObject);
    }).then(action("close-new-party-diaglog", (newPartyLov: LovItem) => {

      let key = (dataObject.relType.directionFrom) ? "toParty" : "fromParty";
      dataObject[key] = newPartyLov;
      dataObject.getForm(formName).updateFieldsPropValue(dataObject, key);
      console.debug("update PartyRel %O", dataObject);
    })).catch( (e) => {});
  };


  newPartyDialogRefHandler = (comp) => this.newPartyDialogRef = comp;


  render() {

    let {dataObject, rootObject, entities, formName} = this.props;
    let {fromParty, toParty, comments, description} = dataObject.getFormFields(formName);

    return (
      <div>
        {(dataObject.$new) ? (
          <div style={{display: 'flex'}}>
            <NewPartyDialog ref={this.newPartyDialogRefHandler}/>
            <h5>Search for {dataObject.relType.roleLabel} to link</h5>

            {
              (dataObject.relType.directionFrom) ?
                <div style={{marginLeft: 15, flexGrow: 1}}>
                  <StyledSelect  {...toParty.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [dataObject.relType.roleId]})}
                                 clearable={true} hintText="type to start search..."/>
                  <Validate field={toParty} value={toParty.props.value}/>
                </div>
                :
                <div style={{marginLeft: 15, flexGrow: 1}}>
                  <StyledSelect  {...fromParty.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [dataObject.relType.roleId]})}
                                 clearable={true} hintText="type to start search..."/>
                  <Validate field={fromParty} value={fromParty.props.value}/>
                </div>
            }
            <FlatButton
              labelStyle={{fontSize: 20}}
              style={{alignSelf: 'center'}}
              label=" or create a new one"
              secondary={true}
              onClick={this.newParty}
            />
          </div>
        ) : null}

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...description.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comments.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );


  }


}




// WEBPACK FOOTER //
// ./src/party/component/partyRelForm.tsx